const fr = {
  lng_name: 'Français',
  item_id_does_not_exist: `L'article {{id}} est absent de votre liste d'articles Kaltura ou a été supprimé.`,
  your_kaltura_item_list_is_empty: `Votre liste d'articles kaltura est vide.`,
  purchase: 'acheter',
  purchased: 'acheté',
  go_to: 'Aller à',
  login_signup: 'Connexion/Inscription',
  logout: 'Déconnexion',
  please_wait: 'Veuillez patienter...',
  thank_you_for_your_purchase: 'Nous vous remercions de votre achat',
  buy_more_channels: 'Acheter plus de chaînes.',
  go_to_premium_content: 'Accéder au contenu premium',
  go_to_purchased_channels: 'Accéder aux chaînes achetées',
};

export default fr;